import './ViewDialog.scss';

import dayjs from 'dayjs';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import useAxiosHook from '../../../../../hooks/useAxiosHook';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { EntityIdRouteParams } from '../../../../../types/routing';
import DialogSpinner from '../../../../Dialogs/DialogSpinner/DialogSpinner';

type Props = {
  isShown: boolean;
  onHide: () => void;
};

function ViewDialog({ isShown, onHide }: Props): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams<EntityIdRouteParams>();
  const isOnMobile = useMediaQuery('(max-width: 768px)');

  const { data: dataPaymentEntity, isLoading: isLoadingPaymentEntity } =
    useAxiosHook<any>(`/v2/payments/${id}`, {
      skipWhen: !isShown && !id,
    });

  return (
    <Dialog
      header={
        isLoadingPaymentEntity ? t('Loading...') : t('Preview on payment')
      }
      // footer={dialogFooter}
      visible={isShown}
      resizable={false}
      onHide={onHide}
      maximizable
      maximized={isOnMobile}
      style={{ width: 580, maxWidth: '100%' }}
      className="payment-view-dialog"
    >
      {isLoadingPaymentEntity ? (
        <DialogSpinner />
      ) : (
        <>
          <span className="section-title">{t('General information')}</span>
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td>{t('Created at')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.createdAt
                    ? dayjs(dataPaymentEntity.createdAt).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )
                    : '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Modified at')}</td>
                <td className="payment-name">
                  {' '}
                  {dataPaymentEntity?.modifiedAt
                    ? dayjs(dataPaymentEntity.modifiedAt).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )
                    : '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Customer Name')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.customerName ?? '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Chargee')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.debtorName ?? '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Payment type')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.paymentTypeName ?? '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Payment status')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.paymentStatusName}
                </td>
              </tr>
              <tr>
                <td>{t('Amount')}</td>
                <td className="payment-name">
                  {dataPaymentEntity?.amount ?? '-'}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </Dialog>
  );
}

export default ViewDialog;
